<template>
	<div v-if="!isLoading">
		<div class="main">
			<div class="text-left pb-6">
				<div class="text-lg mb-4 font-bold">{{ $t('accident_data') }}</div>
				<accident-data-form
					ref="accident-data-form"
					@updateValue="damageCase = $event"
					:start-value="damageCase"
					:show-record-policy="!$store.getters.isProcessComprehensive"
					:show-police-report-image="false"
				/>
				<div v-if="!$store.getters.isProcessComprehensive" class="text-lg mb-4 font-bold">{{ $t('opponent_data') }}</div>
				<OppositePersonForm v-if="!$store.getters.isProcessComprehensive" ref="OppositePersonForm" v-model="damageCase" :show-toggle-button="false" />
			</div>
		</div>
		<div class="flex justify-end">
			<BaseButton @click="save" :disabled="isLoading" class="mb-4 btn-blue">{{ $t('general.save') }}</BaseButton>
		</div>
	</div>
	<div v-else>
		<LoadingSpinner />
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import { DamagecasesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import AccidentDataForm from '../forms/AccidentDataForm';
import OppositePersonForm from '@/components/damagecases/forms/OppositePersonForm';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';

export default {
	name: 'Accident',
	components: { LoadingSpinner, OppositePersonForm, AccidentDataForm, BaseButton },
	data() {
		return { damageCase: {}, isLoading: true };
	},
	methods: {
		getDamageCaseFromApi: function() {
			DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdGet(parseInt(this.$route.params.processId || this.$route.params.id))
				.then(response => {
					this.damageCase = { ...response.data };
					this.isLoading = false;
				})
				.catch(error => {
					this.isLoading = false;
				});
		},
		save() {
			const isAccidentDataFormValid = this.$refs['accident-data-form'].validate();
			const IsOppositePersonFormValid = !this.$store.getters.isProcessComprehensive ? this.$refs['OppositePersonForm'].validate() : true;
			if (isAccidentDataFormValid && IsOppositePersonFormValid) {
				this.isLoading = true;
				DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.damagecasesIdPut(this.damageCase.id, this.damageCase)
					.then(response => {
						this.$store.dispatch('forceUpdateDamageCase');
						this.isLoading = false;
						this.$swal({
							title: this.$t('general.success').toString(),
							text: this.$t('data_saved').toString(),
							icon: 'success',
						}).then(() => {
							this.$store.commit('setConfirmLeaving', false);
							this.$router.push({
								name: 'management.process.edit',
								params: { processId: this.damageCase.id, customer: this.damageCase.customer.id },
							});
						});
					})
					.catch(error => {
						this.isLoading = false;
						this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
					});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
	mounted() {
		if (!this.damageCase.oppositePerson) {
			// TODO LOAD FROM VUEX
			this.getDamageCaseFromApi();
		}
	},
};
</script>

<style scoped></style>
